<template>
  <div class="pagination wrap">
    <a class="page-numbers prev page-arrow disabled" @click="pageChange(page - 5)" />
    <a
      v-for="i in max - min + 1"
      class="page-numbers"
      :class="{ current: min + i - 1 == page }"
      @click="pageChange(min + i - 1)"
    >
      {{ min + i - 1 }}
    </a>
    <a class="page-numbers next page-arrow" @click="pageChange(page + 5)" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  totalCount: number
  pageSize: number
  page: number
}>()

const emits = defineEmits(['update:page'])
const pageCount = computed(() => Math.ceil(props.totalCount / props.pageSize))
const min = computed(() => Math.max(1, Math.min(props.page + 2, pageCount.value) - 4))
const max = computed(() => Math.min(min.value + 4, pageCount.value))

function pageChange(page: number) {
  emits('update:page', Math.max(Math.min(page, pageCount.value), 1))
}
</script>
